/**
 * CONFIGURACIÓN INTEGRACIÓN BACKEND REAL
 * DÍA 5 - PASO INTEGRACIÓN REAL DEL BACKEND
 * Pasos 1 y 2: API Real + WebSocket
 */

import { getApiBaseUrl, getSocketIoUrl } from '@/config/runtimeConfig'

// Backend Configuration
export const BACKEND_CONFIG = {
  // URLs del backend — P12-TEST1A-FE3: lazy ENUMERABLE getters. Importing this module must
  // never invoke a runtime URL resolver at module evaluation (that eager call crashed the
  // release bundle with a TDZ on runtimeConfig's `env`). Reading the property resolves it.
  get API_BASE_URL() { return getApiBaseUrl() },
  get WEBSOCKET_URL() { return `${getSocketIoUrl()}/socket.io/` },

  // Endpoints específicos para Field Supervisor
  ENDPOINTS: {
    // Operaciones de campo
    FIELD_OPERATIONS: '/field-supervisor/operations',
    START_OPERATION: '/field-supervisor/operations/{id}/start',
    PAUSE_OPERATION: '/field-supervisor/operations/{id}/pause',
    COMPLETE_OPERATION: '/field-supervisor/operations/{id}/complete',
    
    // Equipos de trabajo
    WORK_TEAMS: '/field-supervisor/teams',
    ASSIGN_TEAM: '/field-supervisor/teams/{teamId}/assign',
    REASSIGN_TEAM: '/field-supervisor/teams/{teamId}/reassign',
    TEAM_STATUS: '/field-supervisor/teams/{teamId}/status',
    
    // Recursos
    FIELD_RESOURCES: '/field-supervisor/resources',
    REQUEST_RESOURCE: '/field-supervisor/resources/{resourceId}/request',
    TRANSFER_RESOURCE: '/field-supervisor/resources/{resourceId}/transfer',
    RESTOCK_RESOURCE: '/field-supervisor/resources/{resourceId}/restock',
    
    // Comunicaciones
    MESSAGES: '/field-supervisor/messages',
    SEND_MESSAGE: '/field-supervisor/messages/send',
    ALERTS: '/field-supervisor/alerts',
    ACKNOWLEDGE_ALERT: '/field-supervisor/alerts/{alertId}/acknowledge',
    RESOLVE_ALERT: '/field-supervisor/alerts/{alertId}/resolve',
    
    // Reportes y métricas
    PERFORMANCE_METRICS: '/field-supervisor/performance',
    EXPORT_REPORT: '/field-supervisor/reports/export',
    
    // Emergencias
    EMERGENCY_SUPPORT: '/field-supervisor/emergency/support',
    EMERGENCY_BROADCAST: '/field-supervisor/emergency/broadcast',
    EMERGENCY_RESTOCK: '/field-supervisor/emergency/restock'
  },
  
  // Endpoints para Supervisor Zona
  SUPERVISOR_ZONA_ENDPOINTS: {
    GROUP_AGENCIES: '/supervisor-zona/groups/{groupId}/agencies',
    GROUP_EMPLOYEES: '/supervisor-zona/groups/{groupId}/employees',
    UPDATE_AGENCY: '/supervisor-zona/agencies/{agencyId}',
    CHANGE_AGENCY_STATUS: '/supervisor-zona/agencies/{agencyId}/status',
    CREATE_ROUTE: '/supervisor-zona/routes',
    ACTIVE_ROUTE: '/supervisor-zona/groups/{groupId}/active-route',
    UPDATE_VISIT_STATUS: '/supervisor-zona/visits/{visitId}/status',
    CREATE_DEPARTMENT_REPORT: '/supervisor-zona/reports/department'
  },
  
  // WebSocket Events
  WEBSOCKET_EVENTS: {
    // Field Supervisor Events
    OPERATION_STATUS_CHANGED: 'operation_status_changed',
    TEAM_ASSIGNMENT_UPDATED: 'team_assignment_updated',
    RESOURCE_LEVEL_CHANGED: 'resource_level_changed',
    NEW_ALERT: 'new_alert',
    EMERGENCY_ACTIVATED: 'emergency_activated',
    
    // Supervisor Zona Events
    AGENCY_STATUS_UPDATED: 'agency_status_updated',
    NEW_INCIDENT: 'new_incident',
    ROUTE_PROGRESS_UPDATED: 'route_progress_updated',
    EMPLOYEE_STATUS_CHANGED: 'employee_status_changed',
    
    // General Events
    REAL_TIME_UPDATE: 'real_time_update',
    CONNECTION_STATUS: 'connection_status',
    SYSTEM_NOTIFICATION: 'system_notification'
  },
  
  // Configuración de timeouts y reintentos
  TIMEOUTS: {
    API_TIMEOUT: 10000, // 10 segundos
    WEBSOCKET_RECONNECT: 5000, // 5 segundos
    HEARTBEAT_INTERVAL: 30000 // 30 segundos
  },
  
  // Configuración de reintentos
  RETRY_CONFIG: {
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000, // 1 segundo
    EXPONENTIAL_BACKOFF: true
  }
}

// Helper functions para URLs
export const buildApiUrl = (endpoint, params = {}) => {
  let url = `${BACKEND_CONFIG.API_BASE_URL}${endpoint}`
  
  // Reemplazar parámetros en la URL
  Object.keys(params).forEach(key => {
    url = url.replace(`{${key}}`, params[key])
  })
  
  return url
}

export const buildWebSocketUrl = () => {
  return BACKEND_CONFIG.WEBSOCKET_URL
}

// Configuración de headers por defecto
export const getDefaultHeaders = () => {
  const token = localStorage.getItem('auth_token')
  
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  }
}

// Configuración de desarrollo vs producción
export const getEnvironmentConfig = () => {
  const isDevelopment = import.meta.env.DEV
  
  if (isDevelopment) {
    return {
      ...BACKEND_CONFIG,
      API_BASE_URL: getApiBaseUrl(),
      WEBSOCKET_URL: getSocketIoUrl(),
      DEBUG: true
    }
  }
  
  return {
    ...BACKEND_CONFIG,
    API_BASE_URL: getApiBaseUrl(),
    WEBSOCKET_URL: getSocketIoUrl(),
    DEBUG: false
  }
}

export default BACKEND_CONFIG
